// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sevfnoevrufnmkiumfxe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNldmZub2V2cnVmbm1raXVtZnhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYxMTU5NTMsImV4cCI6MjA2MTY5MTk1M30.A5o4GOgkLrIJAQ30EVIgPComJb_ASGMq33Qr6tFqrZI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);